import { useState } from "react";
import * as styles from "./app.module.scss";
import cn from "classnames";

const translations = (window as any).app.preloadState.translation;

function App() {

    const [isLinkCopied, setIsLinkCopied] = useState(false);

    const copyLink = async () => {
        setIsLinkCopied(true);
        await window.navigator.clipboard.writeText(window.location.href);
        setTimeout(() => {
            setIsLinkCopied(false);
        }, 1500);
    }

    return <>{isLinkCopied ?
        <button className={cn(styles.iconButton, styles.iconButtonChecked)}>{translations["productDetailsPageButtons.copiedLink"]}</button>
        :
        <button onClick={copyLink} className={cn(styles.iconButton)}>{translations["productDetailsPageButtons.copyLink"]}</button>
    }
    </>
}

export default App;
